"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxSurveyQuestion = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const useRenderSurveyText_1 = require("../../../features/Survey/hooks/useRenderSurveyText");
const SurveyQuestionProps_1 = require("../../../features/Survey/types/SurveyQuestionProps");
const CheckboxSurveyQuestion = ({ question, onChange }) => {
    const { render } = (0, useRenderSurveyText_1.useRenderSurveyText)();
    const [answers, setAnswers] = (0, react_1.useState)(new Set());
    const handleOnChangeClick = (surveyResponseID) => {
        if (answers.has(surveyResponseID)) {
            answers.delete(surveyResponseID);
        }
        else {
            answers.add(surveyResponseID);
        }
        setAnswers(new Set(answers));
        onChange({
            surveyQuestionResponse: { id: question.id, responses: Array.from(answers).map((id) => ({ id })) },
            status: answers.size > 0 ? SurveyQuestionProps_1.SurveyQuestionStatus.answered : SurveyQuestionProps_1.SurveyQuestionStatus.unanswered,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, alignItems: "flex-start", spacing: 2, direction: "column", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", children: render(question) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { mt: -0.5, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.FormGroup, { children: question.responses.map((response) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { checked: answers.has(response.id), onChange: () => handleOnChangeClick(response.id) }), label: render(response), slotProps: { typography: { variant: 'body2' } } }, response.id))) }) })] }));
};
exports.CheckboxSurveyQuestion = CheckboxSurveyQuestion;
//# sourceMappingURL=CheckboxSurveyQuestion.js.map